import SubModuleHeader from './SubModuleHeader';

export default SubModuleHeader;
